import React, { useEffect } from "react";
import "./AI_ML.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import { Brain, Cpu, BarChart3, Shield, LineChart, Zap } from "lucide-react";
import ai_ml from "../../assets/ai_ml.png";

export default function AI_ML() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div className="aiml-page-content">
        {/* Hero Section */}
        <section
          className="aiml-hero"
          style={{
    backgroundImage: `url(${ai_ml})`,
  }}
        >
          <div className="aiml-hero-overlay"></div>
          <h1 className="aiml-hero-title">
            Transform Your ERP with AI/ML: Intelligent Automation for Manufacturing Success
          </h1>
        </section>

        {/* Sub Headline */}
        <section className="aiml-subheadline">
          <h2>
            Move beyond static data — inject Artificial Intelligence and Machine Learning into your ERP to make every business decision faster, smarter, and more profitable.
          </h2>
        </section>

        {/* What is AI/ML Section */}
        <section className="aiml-intro">
          <h2>What is AI/ML in Manufacturing ERP Software?</h2>
          <p>
            Artificial Intelligence (AI) and Machine Learning (ML) represent the next frontier for Enterprise Resource Planning (ERP) systems in manufacturing. 
            It’s the integration of sophisticated algorithms into ERP, enabling systems to learn from data, recognize patterns, and automate complex, data-driven decisions.
          </p>
          <p>
            Instead of just recording transactions, an AI/ML-powered ERP predicts outcomes, optimizes processes, and generates actionable insights — transforming ERP from a system of record into a system of intelligence.
          </p>
        </section>

        {/* Key Components */}
        <section className="aiml-components">
          <h2>Key Components of our AI/ML ERP Solution</h2>
          <div className="aiml-components-grid">
            <div className="aiml-component">
              <Brain className="aiml-component-icon" />
              <h3>Intelligent Forecasting Engines</h3>
              <p>ML models analyze trends, sales, and external factors for highly accurate demand forecasts, minimizing inventory risk.</p>
            </div>

            <div className="aiml-component">
              <BarChart3 className="aiml-component-icon" />
              <h3>Predictive Analytics Module</h3>
              <p>Uses AI to identify risks like equipment failure, credit risk, or supply chain disruptions before they happen.</p>
            </div>

            <div className="aiml-component">
              <Cpu className="aiml-component-icon" />
              <h3>Cognitive Automation Agents</h3>
              <p>AI automates repetitive tasks like invoice processing and order fulfillment — freeing your staff for strategic work.</p>
            </div>

            <div className="aiml-component">
              <Zap className="aiml-component-icon" />
              <h3>Prescriptive Recommendation System</h3>
              <p>Offers "next best action" guidance for optimizing production, sales, or purchasing decisions.</p>
            </div>

            <div className="aiml-component">
              <Shield className="aiml-component-icon" />
              <h3>Natural Language Processing (NLP)</h3>
              <p>Interact with ERP through conversational commands — simplifying reporting and data retrieval.</p>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="aiml-benefits">
          <h2>Core Benefits of Integrating AI/ML into ERP</h2>
          <div className="aiml-benefit-item">
            <LineChart className="aiml-benefit-icon" />
            <div>
              <h3>Optimized Inventory & Working Capital</h3>
              <p>AI accurately forecasts demand to reduce overstocking and free up capital tied in inventory.</p>
            </div>
          </div>

          <div className="aiml-benefit-item">
            <Cpu className="aiml-benefit-icon" />
            <div>
              <h3>Accelerated Decision Making</h3>
              <p>AI analyzes millions of data points to provide real-time, prescriptive insights for proactive management.</p>
            </div>
          </div>

          <div className="aiml-benefit-item">
            <Shield className="aiml-benefit-icon" />
            <div>
              <h3>Enhanced Financial Accuracy</h3>
              <p>AI automates financial closings, detects anomalies, and improves forecasting for accurate cash flow management.</p>
            </div>
          </div>

          <div className="aiml-benefit-item">
            <Brain className="aiml-benefit-icon" />
            <div>
              <h3>Smarter Production Scheduling</h3>
              <p>Machine Learning adapts schedules dynamically based on machine capacity, labor, and material availability.</p>
            </div>
          </div>

          <div className="aiml-benefit-item">
            <Zap className="aiml-benefit-icon" />
            <div>
              <h3>Improved Customer Experience</h3>
              <p>AI personalizes pricing, recommendations, and responses — boosting satisfaction and loyalty.</p>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section className="aiml-impact">
          <h2>Transforming Operations with Intelligence</h2>
          <p>
            AI and Machine Learning redefine productivity, enabling smarter planning, zero downtime, and data-backed decisions that elevate your competitive advantage.
          </p>
        </section>
      </div>

      <ERPChatbot />
      <Footer />
    </>
  );
}
